export default __webpack_public_path__ + "static/media/modal-error-icon.e9825215.svg";